module.exports = __webpack_public_path__ + "static/img/WATCH_GT2.e22a4d5a.jpg";